<template>
	<div class style="width:100%;" v-loading="loadingPicSign || loadings.upload">
		<a href="javascript:;" class="file" v-show="!isDisabled">
			<span class="el-icon-upload"></span>
			<input type="file" name="file" @change="selectFile" />
		</a>
		<div class="row">
			<div class="col-md-3 picture-card mt-3" v-if="value">
				<el-tooltip placement="left-start">
					<div slot="content">
						<img :src="value+'?x-oss-process=style/thumb'" class="img-thumbnail img-tooltip" />
					</div>
					<img :src="value" class="img-fluid" />
				</el-tooltip>
				<el-button class="remove-btn" icon="el-icon-delete" @click="handleRemovePic()" circle></el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
const OSS = require("ali-oss");
const client = new OSS({
	region: "oss-accelerate",
	// accessKeyId: "LTAIxmyq7VvD5YTb",//lesmo
	// accessKeySecret: "nthzLxzYEplYKOYuWaNrgVqvdBIiTw",
	accessKeyId: "LTAIrJCiyO81cehb", //anon
	accessKeySecret: "9wL8oWTILVkvMkGmJkzDRfPfMi28mV",
	bucket: "unik",
});

const url_replace = [
	'unik.oss-accelerate.aliyuncs.com',
	'unikpics.anontraveler.com'
];

export default {
	data() {
		return {
			id: "",
			loading: false,
			loadings: {
				upload: false,
			},
			fileToUpload: "" + Math.random() + ".jpg",
			timeountHandler: null,
		};
	},
	props: {
		dataModelName: {
			type: String,
			default: "User",
		},
		value: {
			type: String,
			default: "",
		},
		fieldInfo: Object,
		recordId: {
			type: String,
			default: "",
		},
		allowedExt: {
			type: Array,
			default: () => {
				return ["image/png", "image/jpeg", "image/gif"];
			},
		},
		params: {
			type: Object,
			default() {
				return {
					isFlat: false,
				};
			},
		},
	},
	computed: {
		...mapState(["picSign", "loadingPicSign"]),

		isDisabled() {
			return this.value;
		},
		myValue: {
			get: function() {
				return this.value;
			},
			set: function(newValue) {
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
		},
		uploadConfig() {
			if (!this.picSign || this.picSign.expire == 0) {
				return {
					host: "",
					data: {},
				};
			}
			let data = this.picSign;
			let uploadConfig = {
				host: data.host,
				data: {
					policy: data.policy,
					signature: data.signature,
					OSSAccessKeyId: data.accessid,
					success_action_status: 201,
				},
			};

			let dir = this.fieldInfo.dir + "/";
			if (this.fieldInfo.dir_type == "_id" && this.recordId != "") {
				dir += this.recordId + "/";
			} else if (this.fieldInfo.dir_type == "date") {
				let date = new Date();
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				let t = date.getTime();

				dir += "/" + y + "/" + m + "/" + d + "/" + t + "/";
			}
			dir += this.fieldInfo.name + "/";

			uploadConfig.dir = data.dir + dir;

			uploadConfig.data.key = uploadConfig.dir + this.fileToUpload;
			return uploadConfig;
		},
	},
	created() {},
	mounted() {
		if (this.timeountHandler) {
			clearInterval(this.timeountHandler);
		}
		this.getPicSign();
		//随机刷阿里云签名认证，防止一堆组件同时刷发起多个请求
		this.timeountHandler = setInterval(() => {
			this.getPicSign();
		}, Math.random() * 100000 + 3600000);
	},
	beforeDestroy() {
		if (this.timeountHandler) {
			clearInterval(this.timeountHandler);
		}
	},
	methods: {
		...mapMutations(["getPicSign"]),

		handleRemovePic() {
			this.myValue = "";
		},
		selectFile(e) {
			if (this.myValue) {
				this.handleExceed();
				return;
			}
			debugger;

			for (let i = 0; i < e.target.files.length; i++) {
				if (
					!this.allowedExt.find(val => {
						return val == e.target.files[i].type;
					})
				) {
					this.$message({
						type: "error",
						message: "文件格式不正确",
					});
					return;
				}
				this.pushFile(e.target.files[i]);
			}
		},
		pushFile(file) {
			this.loadings.upload = true;
			client
				.put(this.uploadConfig.dir + file.name, file)
				.then(result => {
					this.loadings.upload = false;
					this.myValue = result.url.replace(url_replace[0],url_replace[1]);
				})
				.catch(err => {
					this.loadings.upload = false;
					console.error(err);
				});
		},
	},
	components: {},
};
</script>
<style lang="scss" >
.upload-field {
	width: 182px;
	display: flex;

	.el-upload-list--picture-card {
		display: block;
	}
	.el-upload-list--picture-card .el-upload-list__item {
		width: 180px;
	}
	.el-upload--picture-card {
		width: 180px;
		height: 240px;
		border: none;
	}
	.el-upload-dragger {
		width: 180px;
		height: 240px;
	}
	&.isFlat {
		.el-upload-list--picture-card.el-upload-list__item {
			height: 66px;
		}
		.el-upload--picture-card {
			height: 66px;
			line-height: 66px;
			border: none;
		}
		.el-upload-dragger {
			height: 66px;
			display: flex;
			align-content: center;
			justify-items: center;
		}
		.el-upload-dragger .el-icon-upload {
			margin: 0 auto;
		}
	}

	&.disabled {
		.el-upload {
			display: none;
		}
	}
}
</style>
